'use client';

import React from 'react';

interface PortfolioFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const PortfolioFilter = ({ categories, activeCategory, onCategoryChange }: PortfolioFilterProps) => {
  return (
    <div data-component-id="src/app/portfolio/components/PortfolioFilter.tsx:13:4" data-component-path="src/app/portfolio/components/PortfolioFilter.tsx" data-component-line="13" data-component-end-line="27" data-component-file="PortfolioFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20justify-center%20gap-3%20mb-12%22%7D" className="flex flex-wrap justify-center gap-3 mb-12">
      {categories.map((category) => (
        <button data-component-id="src/app/portfolio/components/PortfolioFilter.tsx:15:8" data-component-path="src/app/portfolio/components/PortfolioFilter.tsx" data-component-line="15" data-component-end-line="25" data-component-file="PortfolioFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-6 py-3 rounded-lg font-cta font-semibold text-sm transition-all duration-300 ${
            activeCategory === category
              ? 'bg-primary text-primary-foreground shadow-card scale-105'
              : 'bg-muted text-muted-foreground hover:bg-secondary hover:text-secondary-foreground hover:scale-105'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default PortfolioFilter;